<ng-container *transloco="let t">
  <div class="grid h-full grid-cols-1 lg:grid-cols-2">
    <div class="flex h-full flex-col justify-center gap-6">
      <h1 class="text-3xl font-bold">
        {{ t('welcome-header') }}
      </h1>
      <p>{{ t('welcome-salutation') }}</p>
      <p [innerHTML]="translocoService.translate('welcome-text')"></p>
      <p [innerHTML]="translocoService.translate('welcome-registration')"></p>
    </div>
    <div class="flex h-full flex-col items-center justify-center gap-6">
      <div class="max-w-md space-y-2 text-center">
        <h2 class="text-2xl font-bold md:text-3xl">
          {{ t('login-now') }}
        </h2>
        <!--
      <p class="hidden sm:block">
        {{ t('login-description') }}
      </p>
      --></div>
      <div class="card bg-base-100 w-full max-w-sm shadow-2xl">
        <div class="card-body">
          <form [formGroup]="loginFormGroup" (ngSubmit)="login()">
            <div class="fieldset space-y-1">
              <div class="space-y-1">
                <label
                  class="input input-lg floating-label w-full text-sm"
                  [ngClass]="{
                    'input-error':
                      loginFormGroupEmail?.invalid &&
                      loginFormGroupEmail?.touched,
                  }"
                >
                  <svg
                    class="h-[1em] self-center opacity-50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <g
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      stroke-width="2.5"
                      fill="none"
                      stroke="currentColor"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      <path
                        d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                      ></path>
                    </g>
                  </svg>
                  <span>
                    {{ t('login-email') }}
                  </span>
                  <input
                    [attr.aria-invalid]="
                      loginFormGroupEmail?.invalid &&
                      loginFormGroupEmail?.touched
                        ? true
                        : null
                    "
                    [required]="true"
                    class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                    formControlName="email"
                    [placeholder]="t('login-email')"
                    type="email"
                  />
                </label>
                @if (
                  loginFormGroupEmail?.invalid &&
                  loginFormGroupEmail?.touched &&
                  loginFormGroupEmail?.errors?.['email']
                ) {
                  <p class="text-error">
                    {{ t('register-user-form-error-email-format') }}
                  </p>
                }
              </div>

              <div class="space-y-1">
                <label
                  class="input input-lg floating-label w-full text-sm"
                  [ngClass]="{
                    'input-error':
                      loginFormGroupPassword?.invalid &&
                      loginFormGroupPassword?.touched,
                  }"
                >
                  <svg
                    class="h-[1em] opacity-50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <g
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      stroke-width="2.5"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
                      ></path>
                      <circle
                        cx="16.5"
                        cy="7.5"
                        r=".5"
                        fill="currentColor"
                      ></circle>
                    </g>
                  </svg>
                  <span>
                    {{ t('login-password') }}
                  </span>
                  <input
                    [attr.aria-invalid]="
                      loginFormGroupPassword?.invalid &&
                      loginFormGroupPassword?.touched
                        ? true
                        : null
                    "
                    [attr.aria-label]="t('login-password')"
                    [type]="getLoginFormGroupPasswordInputType()"
                    autocomplete="on"
                    class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                    formControlName="password"
                    [placeholder]="t('login-password')"
                  />
                  <button
                    (click)="toggleShowPassword()"
                    class="btn btn-square btn-ghost transition-none hover:border-0 hover:bg-transparent focus:outline-none"
                    type="button"
                    [disabled]="loginFormGroupPassword?.value?.length === 0"
                  >
                    <svg
                      class="h-6 w-6"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      @if (showPassword()) {
                        <path
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      } @else {
                        <path
                          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      }
                    </svg>
                  </button>
                </label>
              </div>

              @if (error$ | async; as error) {
                @if (
                  error.generic || error.invalidCredentials || error.timeout
                ) {
                  <div
                    class="alert alert-error flex items-center justify-center p-3 text-center"
                    role="alert"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 shrink-0 stroke-current"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    @if (error.invalidCredentials) {
                      <span>
                        {{ t('login-error-invalid-credentials') }}
                      </span>
                    }
                    @if (error.generic) {
                      <span>
                        {{ t('login-error-generic-error-message') }}
                      </span>
                    }
                    @if (error.timeout) {
                      <span>
                        {{ t('login-error-timeout') }}
                      </span>
                    }
                  </div>
                }
              }
              <div class="label">
                <a
                  [routerLink]="[
                    '/',
                    coreRoutesNames.AUTH,
                    authRoutesNames.FORGOT_PASSWORD,
                  ]"
                  class="link-hover link label-text-alt"
                >
                  {{ t('login-forgot-password') }}
                </a>
              </div>
              <button
                class="btn btn-lg btn-primary text-sm"
                type="submit"
                [disabled]="loginFormGroup.invalid || authStore.isLoading()"
              >
                {{ t('login-button') }}
                @if (authStore.isLoading()) {
                  <span class="loading loading-sm loading-spinner"></span>
                }
              </button>
              <button
                class="btn btn-lg btn-neutral text-sm"
                type="button"
                (click)="register()"
              >
                {{ t('register-user-button') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>
